import { useCallback, useEffect, useState } from 'react'

function useFetchData(fn, body) {
  const [data, setData] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = useCallback(
    async (fn) => {
      setLoading(true)
      const response = await fn(body)
      setLoading(false)

      setData(response)
    },
    [body]
  )

  useEffect(() => {
    fetchData(fn)
  }, [fn, body, fetchData])

  const refreshData = async () => fetchData(fn)

  return { data, refreshData, loading }
}

export default useFetchData
